import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './LeadGeneration.css';

const LeadGeneration = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);

    // Set up interval to cycle through features
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % 3);
    }, 3000); // Change active feature every 3 seconds

    return () => clearInterval(interval); // Clean up on unmount
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Best WhatsApp Integrated Lead Qualification, Generation and Conversion AI Chatbot
        </title>
        <meta
          name="description"
          content="Our AI-powered smart chatbot lead generation technology helps to engage, capture, qualify, and nurture leads 24/7 with full customer support automation."
        />
        <meta
          name="keywords"
          content="AI Lead Generation Engine, lead generation, lead generation by engaging customers, Lead Gen Bot, streamline lead generation, leads for B2c & D2C"
        />
        <link rel="canonical" href="https://www.aichatassist.com/features/lead-generation" />

        {/* Open Graph Meta */}
        <meta
          property="og:title"
          content="Lead Generation by AI | AI Chat Assist in SG, UK & UAE"
        />
        <meta
          property="og:description"
          content="AI Chat Assist powers intelligent lead generation by engaging customers. Drive growth in Singapore, UK & UAE with our AI-driven solutions."
        />
        <meta property="og:url" content="https://www.aichatassist.com/features/lead-generation" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta property="og:site_name" content="AI Chat Assist" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Lead Generation by AI | AI Chat Assist in SG, UK & UAE"
        />
        <meta
          name="twitter:description"
          content="AI Chat Assist powers intelligent lead generation by engaging customers. Drive growth in Singapore, UK & UAE with our AI-driven solutions."
        />
        <meta
          name="twitter:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta name="twitter:site" content="@aichatassist" />
      </Helmet>

      {/* Hero Section */}
      <section className="page-hero-section py-5">
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-7 text-center text-lg-start">
              <div
                className="d-inline-flex align-items-center bg-dark text-white px-3 py-2 rounded-pill mb-4 hero-badge"
                style={{ background: `var(--purple-gradient)` }}
              >
                <span className="small">Your Smart Lead Generation Companion</span>
              </div>

              <h1 className="hero-heading mb-4 animate-up">
                <span>The Ultimate</span>
                <br />
                <span className="hero-highlight">AI Lead Generation</span>
                <br />
                <span className="">Engine</span>
              </h1>

              <p
                className="lead text-muted mb-5"
                style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}
              >
                Engage customers, qualify prospects, and boost conversions with our Lead Gen Bot
                that works across your digital platforms.
              </p>
            </div>

            <div className="col-lg-5 mt-5 mt-lg-0">
              <div className="position-relative">
                <img
                  src="/images/conversion1.svg"
                  alt="Lead Generation"
                  className="img-fluid rounded-4 hero-image-leadGen"
                  style={{ maxWidth: '100%', width: '100%' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'perspective(1000px) rotateY(5deg)';
                  }}
                />

                {/* Floating Review Card */}
                {/* <div className="position-absolute bg-white p-3 rounded-3 shadow-sm floating-review-card" style={{ top: '10%', right: '0%', maxWidth: '160px', zIndex: 3 }}>
                  <div className="d-flex mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" className="bi bi-star-fill me-1" viewBox="0 0 16 16">
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" className="bi bi-star-fill me-1" viewBox="0 0 16 16">
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" className="bi bi-star-fill me-1" viewBox="0 0 16 16">
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" className="bi bi-star-fill me-1" viewBox="0 0 16 16">
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" className="bi bi-star-fill" viewBox="0 0 16 16">
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                  </div>
                  <h6 className="mb-2">Best on the market</h6>
                  <p className="small text-muted mb-1">I love this product because the lead generation is great. Please...</p>
                  <p className="small fw-bold mb-0">Alex White</p>
                </div> */}

                {/* Floating Stats Card */}
                {/* <div className="position-absolute bg-white p-3 rounded-3 shadow-sm floating-stats-card" style={{ bottom: '15%', left: '-10%', maxWidth: '180px', zIndex: 3 }}>
                  <h5 className="mb-1">Goal-Based Leads</h5>
                  <p className="small text-muted mb-0">Convert prospects with personalized insights and targeted campaigns.</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Background decorative elements */}
        {/* <div className="hero-background-circle-1"></div> */}
        {/* <div className="hero-background-circle-2"></div> */}
      </section>

      {/* Templates Section - Matching the image layout exactly with brand colors */}
      <section id="templates" className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="row g-4">
                {/* First row */}
                <div className="col-md-4 mb-4">
                  <div className="template-card pink-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#8c6fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                        <line x1="8" y1="21" x2="16" y2="21"></line>
                        <line x1="12" y1="17" x2="12" y2="21"></line>
                      </svg>
                    </div>
                    <h4>Qualify Leads Automatically</h4>
                    <div className="category-label mb-2">ENGAGEMENT</div>
                    <p className="card-description">
                      Identify high-quality leads instantly based on your sales criteria.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="template-card brand-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </div>
                    <h4 className="text-white">Capture from Any Channel</h4>
                    <div className="category-label mb-2">CHANNELS</div>
                    <p className="card-description text-white">
                      Collect leads from WhatsApp, your site, or social messaging apps.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="template-card white-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ce75ff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                      </svg>
                    </div>
                    <h4>Real-Time Visitor Engagement</h4>
                    <div className="category-label mb-2">AUTOMATION</div>
                    <p className="card-description">
                      Start conversations as visitors browse, with context-aware AI prompts.
                    </p>
                  </div>
                </div>

                {/* Second row */}
                <div className="col-md-4 mb-4">
                  <div className="template-card white-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#8c6fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <path d="M9 13h6"></path>
                        <path d="M9 17h6"></path>
                        <path d="M9 9h1"></path>
                      </svg>
                    </div>
                    <h4>Route to Sales Instantly</h4>
                    <div className="category-label mb-2">WORKFLOW</div>
                    <p className="card-description">
                      Send leads directly to your CRM or sales team for quick follow-up.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="template-card orange-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#8c6fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                    </div>
                    <h4>Scale B2C & D2C Campaigns</h4>
                    <div className="category-label mb-2">SCALABILITY</div>
                    <p className="card-description">
                      Automate campaigns for high-volume lead gen with ease.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="template-card gray-card">
                    <div className="template-icon mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ce75ff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="8" y1="6" x2="21" y2="6"></line>
                        <line x1="8" y1="12" x2="21" y2="12"></line>
                        <line x1="8" y1="18" x2="21" y2="18"></line>
                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                      </svg>
                    </div>
                    <h4>Boost ROI from Day One</h4>
                    <div className="category-label mb-2">RESULTS</div>
                    <p className="card-description">
                      Improve conversions through timely engagement and smart lead flows.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="templates-info">
                <h3>Turn Conversations into Conversions</h3>
                <p className="mb-4" style={{ color: '#555', lineHeight: '1.6' }}>
                  Engage prospects on WhatsApp, web, and social channels. Our AI Lead Generation
                  Engine captures and qualifies leads in real time—helping you scale without manual
                  effort.
                </p>
                {/* <button className="btn btn-primary-gradient rounded-pill px-4 py-2">
                  Start Generating Leads
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className=" py-5" id="how-it-works">
        <div className="container">
          <div className="section-heading text-center mb-5">
            <h2>
              How It <span className="highlight hero-highlight">Works</span>
            </h2>
            <p>Our lead generation process from engagement to conversion</p>
          </div>

          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="timeline-container">
                <div className="timeline-line"></div>

                {[
                  {
                    number: 1,
                    title: 'Engage Visitors',
                    description:
                      'Start conversations automatically with the Lead Gen Bot, using real-time triggers to connect with site visitors.',
                    icon: 'chat-dots',
                  },
                  {
                    number: 2,
                    title: 'Qualify Prospects',
                    description:
                      'Use AI to ask smart, pre-configured questions and filter out high-intent leads instantly.',
                    icon: 'filter-circle',
                  },
                  {
                    number: 3,
                    title: 'Collect Information',
                    description:
                      'Gather contact details through chat, without relying on static forms—making the process frictionless.',
                    icon: 'clipboard-data',
                  },
                  {
                    number: 4,
                    title: 'Nurture Leads',
                    description:
                      'Share relevant answers, links, and next steps to keep leads engaged throughout their journey.',
                    icon: 'diagram-3',
                  },
                  {
                    number: 5,
                    title: 'Convert & Transfer',
                    description:
                      'Hand off qualified leads to your CRM or sales team seamlessly, with context and timing that drive action.',
                    icon: 'arrow-left-right',
                  },
                ].map((step, index) => (
                  <div
                    key={index}
                    className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div className="timeline-badge">
                      {/* <div className="timeline-number">{step.number}</div> */}
                      <div className="timeline-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          fill="currentColor"
                          className={`bi bi-${step.icon}`}
                          viewBox="0 0 16 16"
                        >
                          {step.icon === 'chat-dots' && (
                            <>
                              <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                              <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z" />
                            </>
                          )}
                          {step.icon === 'filter-circle' && (
                            <>
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="M7 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z" />
                            </>
                          )}
                          {step.icon === 'clipboard-data' && (
                            <>
                              <path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" />
                              <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                              <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                            </>
                          )}
                          {step.icon === 'diagram-3' && (
                            <path
                              fillRule="evenodd"
                              d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6h-1A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                            />
                          )}
                          {step.icon === 'arrow-left-right' && (
                            <>
                              <path
                                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
                                fill="#f0f0ff"
                              />
                              <path
                                d="M11.5 8a.5.5 0 0 1-.5.5H4.707l1.647 1.646a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708.708L4.707 7.5H11a.5.5 0 0 1 .5.5z"
                                fill="currentColor"
                              />
                              <path
                                d="M4.5 8a.5.5 0 0 1 .5-.5h6.293l-1.647-1.646a.5.5 0 0 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L11.293 8.5H5a.5.5 0 0 1-.5-.5z"
                                fill="currentColor"
                              />
                            </>
                          )}
                        </svg>
                      </div>
                    </div>
                    <div className="timeline-panel">
                      <div className="timeline-content">
                        <h3 className="timeline-title">{step.title}</h3>
                        <p className="timeline-description">{step.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Add CSS for the timeline animation */}
        <style jsx>{`
          .timeline-container {
            position: relative;
            padding: 40px 0;
          }

          .timeline-line {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50%;
            width: 2px;
            margin-left: -1px;
            background: linear-gradient(
              to bottom,
              rgba(var(--primary-color-rgb), 0.3),
              rgba(var(--primary-color-rgb), 0.9)
            );
            transform: translateZ(0);
            animation: grow-line 1.5s ease-out forwards;
            transform-origin: top center;
            box-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.2);
          }

          @keyframes grow-line {
            0% {
              transform: scaleY(0);
            }
            100% {
              transform: scaleY(1);
            }
          }

          .timeline-item {
            position: relative;
            margin-bottom: 60px;
            width: 50%;
            animation-duration: 0.8s;
            animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
            animation-fill-mode: both;
          }

          .timeline-item.left {
            left: 0;
            padding-right: 50px;
            text-align: right;
            animation-name: slide-in-left;
          }

          .timeline-item.right {
            left: 50%;
            padding-left: 50px;
            text-align: left;
            animation-name: slide-in-right;
          }

          @keyframes slide-in-left {
            0% {
              opacity: 0;
              transform: translateX(-50px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes slide-in-right {
            0% {
              opacity: 0;
              transform: translateX(50px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }

          .timeline-badge {
            position: absolute;
            top: 0;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: white;
            border: 3px solid var(--primary-color);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 2;
            animation: pulse 2s infinite;
            box-shadow: 0 0 15px rgba(var(--primary-color-rgb), 0.4);
            transition: all 0.3s ease;
          }

          .timeline-badge:hover {
            transform: scale(1.1);
            box-shadow: 0 0 20px rgba(var(--primary-color-rgb), 0.6);
          }

          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(var(--primary-color-rgb), 0.4);
            }
            70% {
              box-shadow: 0 0 0 15px rgba(var(--primary-color-rgb), 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(var(--primary-color-rgb), 0);
            }
          }

          .timeline-item.left .timeline-badge {
            right: -30px;
          }

          .timeline-item.right .timeline-badge {
            left: -30px;
          }

          .timeline-number {
            position: absolute;
            font-weight: bold;
            color: var(--primary-color);
            font-size: 22px;
          }

          .timeline-icon {
            color: var(--primary-color);
            opacity: 0;
            animation: fade-in 0.5s ease-in forwards;
            animation-delay: 0.8s;
          }

          @keyframes fade-in {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          .timeline-panel {
            padding: 30px;
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            transition: all 0.4s ease;
            border: 1px solid rgba(0, 0, 0, 0.05);
            position: relative;
            overflow: hidden;
          }

          .timeline-panel:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 5px;
            height: 100%;
            background: var(--purple-gradient);
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .timeline-item.left .timeline-panel:before {
            left: auto;
            right: 0;
          }

          .timeline-panel:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
          }

          .timeline-panel:hover:before {
            opacity: 1;
          }

          .timeline-title {
            color: #212529;
            font-weight: 600;
            margin-bottom: 15px;
            position: relative;
            display: inline-block;
            font-size: 1.4rem;
          }

          .timeline-title:after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 0;
            height: 2px;
            background-color: var(--primary-color);
            transition: width 0.3s ease;
          }

          .timeline-item.right .timeline-title:after {
            left: 0;
          }

          .timeline-item.left .timeline-title:after {
            right: 0;
            left: auto;
          }

          .timeline-panel:hover .timeline-title:after {
            width: 100%;
          }

          .timeline-description {
            color: #6c757d;
            margin-bottom: 0;
            line-height: 1.6;
            font-size: 1.05rem;
          }

          /* Add animation delay for each item */
          .timeline-item:nth-child(1) {
            animation-delay: 0.1s;
          }

          .timeline-item:nth-child(2) {
            animation-delay: 0.3s;
          }

          .timeline-item:nth-child(3) {
            animation-delay: 0.5s;
          }

          .timeline-item:nth-child(4) {
            animation-delay: 0.7s;
          }

          .timeline-item:nth-child(5) {
            animation-delay: 0.9s;
          }

          /* Responsive adjustments */
          @media (max-width: 767px) {
            .timeline-line {
              left: 30px;
            }

            .timeline-item {
              width: 100%;
              padding-left: 70px;
              padding-right: 15px;
              text-align: left;
              margin-bottom: 50px;
            }

            .timeline-item.left,
            .timeline-item.right {
              left: 0;
              padding-left: 70px;
              padding-right: 15px;
              text-align: left;
            }

            .timeline-item.left .timeline-badge,
            .timeline-item.right .timeline-badge {
              left: 0;
            }

            .timeline-item.left .timeline-title:after,
            .timeline-item.right .timeline-title:after {
              left: 0;
              right: auto;
            }

            .timeline-item.left .timeline-panel:before,
            .timeline-item.right .timeline-panel:before {
              left: 0;
              right: auto;
            }
          }
        `}</style>

        {/* Add script for animation on scroll */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
            document.addEventListener('DOMContentLoaded', function() {
              const timelineItems = document.querySelectorAll('.timeline-item');
              
              function checkInView() {
                timelineItems.forEach(item => {
                  const rect = item.getBoundingClientRect();
                  const isInView = (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                  );
                  
                  if (isInView) {
                    item.style.animationPlayState = 'running';
                  }
                });
              }
              
              // Set initial animation state to paused
              timelineItems.forEach(item => {
                item.style.animationPlayState = 'paused';
              });
              
              // Check on load and scroll
              window.addEventListener('scroll', checkInView);
              window.addEventListener('resize', checkInView);
              checkInView();
            });
          `,
          }}
        />
      </section>

      {/* Lead Generation Features Section */}
      <section className="py-5" id="features">
        <div className="container">
          <div className="section-heading text-center mb-5">
            <h2>
              Powerful <span className="highlight hero-highlight">Features</span>
            </h2>
            <p>Streamlined tools to convert visitors into qualified leads</p>
          </div>

          <section className="lead-qualification-section py-5 mb-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-4 d-flex flex-column justify-content-center order-lg-1">
                  <div className="feature-points-container">
                    <div
                      className={`feature-point ${activeFeature === 0 ? 'active' : ''}`}
                      onClick={() => setActiveFeature(0)}
                    >
                      <div className="feature-point-number">1</div>
                      <div className="feature-point-content">
                        <h3 className="feature-point-title">Capture</h3>
                        <p className="feature-point-text">
                          Start lead generation by engaging customers in real time with personalized
                          chats across your website and WhatsApp.
                        </p>
                      </div>
                    </div>

                    <div
                      className={`feature-point ${activeFeature === 1 ? 'active' : ''}`}
                      onClick={() => setActiveFeature(1)}
                    >
                      <div className="feature-point-number">2</div>
                      <div className="feature-point-content">
                        <h3 className="feature-point-title">Qualify</h3>
                        <p className="feature-point-text">
                          Use the AI Lead Generation Engine to identify high-value leads based on
                          your business filters and customer responses.
                        </p>
                      </div>
                    </div>

                    <div
                      className={`feature-point ${activeFeature === 2 ? 'active' : ''}`}
                      onClick={() => setActiveFeature(2)}
                    >
                      <div className="feature-point-number">3</div>
                      <div className="feature-point-content">
                        <h3 className="feature-point-title">Route</h3>
                        <p className="feature-point-text">
                          Instantly assign qualified leads to the right team or CRM system to
                          accelerate your conversion process.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 d-flex justify-content-center align-items-center order-lg-2">
                  <div className="phone-container text-center">
                    <img
                      src="/images/section2feature.png"
                      alt="Lead Qualification"
                      className="img-fluid phone-mockup"
                      style={{
                        maxWidth: '280px',
                        borderRadius: '36px',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'perspective(1000px) rotateY(5deg)';
                      }}
                    />
                  </div>
                </div>

                <div className="col-lg-4 d-flex flex-column justify-content-center order-lg-3">
                  <div className="lead-qualification-heading">
                    <h2 className="section-title">
                      Smart <br />{' '}
                      <span className="highlight hero-highlight">Lead Qualification</span>
                    </h2>
                    <p className="lead mb-4">
                      Automate how you filter, sort, and prioritize leads with intelligent chat.
                      Focus your sales efforts where it matters most.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="row align-items-center mb-5 flex-lg-row-reverse multi-channel-container">
            <div className="col-lg-6">
              <div className="p-4 multi-channel-content">
                <h2 className="mb-3 multi-channel-title">
                  Multi-Channel <span className="highlight hero-highlight">Lead Capture</span>
                </h2>
                <p className="lead mb-4">
                  Reach your audience wherever they are—website, WhatsApp, or social apps. Our AI
                  Chatbot makes lead generation seamless across every touchpoint.
                </p>
                <ul className="animated-feature-list">
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Website chat with smart prompts</span>
                      <span className="animated-feature-description">
                        Start personalized chats that turn visits into qualified leads
                      </span>
                    </div>
                  </li>
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">WhatsApp integration</span>
                      <span className="animated-feature-description">
                        Generate leads directly from WhatsApp Business with our AI Lead Gen Bot
                      </span>
                    </div>
                  </li>
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Social messaging support</span>
                      <span className="animated-feature-description">
                        Connect through Facebook, Instagram, and LinkedIn to expand reach
                      </span>
                    </div>
                  </li>
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Email automation</span>
                      <span className="animated-feature-description">
                        Engage leads through targeted follow-ups using your email tools
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="multi-channel-icons-container">
                <div className="social-media-icons-grid">
                  {/* Facebook */}
                  <div className="channel-icon-card facebook">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        fill="#1877F2"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                      </svg>
                    </div>
                    <div className="icon-label">Facebook</div>
                  </div>
                  {/* Twitter */}
                  <div className="channel-icon-card twitter">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        fill="#1DA1F2"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                      </svg>
                    </div>
                    <div className="icon-label">Twitter</div>
                  </div>
                  {/* LinkedIn */}
                  <div className="channel-icon-card linkedin">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        fill="#0A66C2"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                      </svg>
                    </div>
                    <div className="icon-label">LinkedIn</div>
                  </div>
                  {/* Pinterest */}
                  <div className="channel-icon-card pinterest">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        fill="#E60023"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0z" />
                      </svg>
                    </div>
                    <div className="icon-label">Pinterest</div>
                  </div>
                  {/* Instagram */}
                  <div className="channel-icon-card instagram">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 16 16"
                      >
                        <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                          <stop offset="0%" stopColor="#FFDC80" />
                          <stop offset="20%" stopColor="#FCAF45" />
                          <stop offset="40%" stopColor="#F77737" />
                          <stop offset="60%" stopColor="#F56040" />
                          <stop offset="80%" stopColor="#FD1D1D" />
                          <stop offset="100%" stopColor="#C13584" />
                        </linearGradient>
                        <path
                          fill="url(#instagram-gradient)"
                          d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                        />
                      </svg>
                    </div>
                    <div className="icon-label">Instagram</div>
                  </div>
                  {/* WhatsApp */}
                  <div className="channel-icon-card whatsapp">
                    <div className="channel-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        fill="#25D366"
                        viewBox="0 0 16 16"
                      >
                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                      </svg>
                    </div>
                    <div className="icon-label">WhatsApp</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <div className="p-4 multi-channel-content">
                <h2 className="mb-3 multi-channel-title">
                  Automated <span className="highlight hero-highlight">Lead Nurturing</span>
                </h2>
                <p className="lead mb-4">
                  Build trust and guide leads through your funnel with timely, relevant
                  messaging—powered by AI and customer behavior.
                </p>
                <ul className="animated-feature-list">
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Custom follow-ups</span>
                      <span className="animated-feature-description">
                        Send messages based on each lead’s journey and responses
                      </span>
                    </div>
                  </li>
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Smart content delivery</span>
                      <span className="animated-feature-description">
                        Share resources that match a lead’s interests and stage
                      </span>
                    </div>
                  </li>
                  <li className="animated-feature-item">
                    <div className="animated-feature-icon-wrapper brand-gradient">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        fill="currentColor"
                        className="animated-feature-icon"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                    </div>
                    <div className="animated-feature-content">
                      <span className="animated-feature-text">Engagement tracking</span>
                      <span className="animated-feature-description">
                        See how leads interact with content to refine your campaigns
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="lead-nurturing-container" style={{ backgroundColor: 'transparent' }}>
                <div
                  className="lead-nurturing-images-container"
                  style={{ backgroundColor: 'transparent' }}
                >
                  <div
                    className="lead-nurturing-images-grid"
                    style={{ backgroundColor: 'transparent' }}
                  >
                    <div className="nurturing-image-card email">
                      <div className="nurturing-image icon-container">
                        <i className="fas fa-envelope icon-gradient"></i>
                      </div>
                      <div className="image-label">Email Campaigns</div>
                    </div>
                    <div className="nurturing-image-card analytics">
                      <div className="nurturing-image icon-container">
                        <i className="fas fa-chart-bar icon-gradient"></i>
                      </div>
                      <div className="image-label">Analytics</div>
                    </div>
                    {/* <div className="nurturing-image-card personalization">
                      <div className="nurturing-image icon-container">
                        <i className="fas fa-user-check icon-gradient"></i>
                      </div>
                      <div className="image-label">Personalization</div>
                    </div> */}
                    <div className="nurturing-image-card content">
                      <div className="nurturing-image icon-container">
                        <i className="fas fa-file-alt icon-gradient"></i>
                      </div>
                      <div className="image-label">Content Library</div>
                    </div>
                    <div className="nurturing-image-card automation">
                      <div className="nurturing-image icon-container">
                        <i className="fas fa-cogs icon-gradient"></i>
                      </div>
                      <div className="image-label">Automation</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .features-section {
            background-color: #f8f9fa;
            position: relative;
            overflow: hidden;
          }

          .feature-content {
            position: relative;
            z-index: 2;
          }

          .feature-content h2 {
            font-weight: 700;
            margin-bottom: 20px;
          }

          .feature-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 60px;
            border-radius: 12px;
            background: linear-gradient(135deg, #0d6efd, #6610f2);
            color: white;
          }

          .feature-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .feature-list li {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            font-size: 1.05rem;
          }

          .feature-list li svg {
            color: #0d6efd;
            flex-shrink: 0;
          }

          .feature-image {
            position: relative;
            z-index: 2;
          }

          @media (max-width: 991px) {
            .row.flex-lg-row-reverse {
              flex-direction: column-reverse;
            }

            .feature-content,
            .feature-image {
              padding: 20px;
              margin-bottom: 20px;
            }
          }
        `}</style>
      </section>

      {/* Integration Section */}
      {/* <section className="integration-section py-5">
        <div className="container">
          <div className="section-heading text-center mb-5">
            <h2>Seamless <span className="highlight">Integrations</span></h2>
            <p>Connect with your existing tools and systems</p>
          </div>

          <div className="row g-4 justify-content-center">
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/salesforce.png" alt="Salesforce" />
                <p>Salesforce</p>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/hubspot.png" alt="HubSpot" />
                <p>HubSpot</p>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/zoho.png" alt="Zoho CRM" />
                <p>Zoho CRM</p>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/pipedrive.png" alt="Pipedrive" />
                <p>Pipedrive</p>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/mailchimp.png" alt="Mailchimp" />
                <p>Mailchimp</p>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="integration-logo">
                <img src="/images/integrations/zapier.png" alt="Zapier" />
                <p>Zapier</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <Link to="/platform/crm-api-integration" className="btn btn-outline-primary">View All Integrations</Link>
          </div>
        </div>
      </section> */}

      {/* Success Stories Section
      <section className="success-stories-section py-5">
        <div className="container">
          <div className="section-heading text-center mb-5">
            <h2>Success <span className="highlight">Stories</span></h2>
            <p>See how businesses are generating more leads with AI Chat Assist</p>
          </div>

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="success-story-card">
                <div className="success-story-content">
                  <div className="success-story-logo">
                    <img src="/images/clients/client-1.png" alt="TechNova" />
                  </div>
                  <h4>TechNova</h4>
                  <p className="success-story-industry">SaaS Company</p>
                  <div className="success-story-stats">
                    <div className="stat">
                      <h5>147%</h5>
                      <p>Increase in qualified leads</p>
                    </div>
                    <div className="stat">
                      <h5>24/7</h5>
                      <p>Lead capture</p>
                    </div>
                  </div>
                  <p className="success-story-quote">
                    "AI Chat Assist transformed our lead generation process. We're now capturing qualified leads around the clock with minimal effort from our team."
                  </p>
                  <p className="success-story-author">- Sarah Chen, Marketing Director</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="success-story-card">
                <div className="success-story-content">
                  <div className="success-story-logo">
                    <img src="/images/clients/client-2.png" alt="GreenHome Realty" />
                  </div>
                  <h4>GreenHome Realty</h4>
                  <p className="success-story-industry">Real Estate Agency</p>
                  <div className="success-story-stats">
                    <div className="stat">
                      <h5>89%</h5>
                      <p>More property inquiries</p>
                    </div>
                    <div className="stat">
                      <h5>3.5x</h5>
                      <p>ROI increase</p>
                    </div>
                  </div>
                  <p className="success-story-quote">
                    "Our chatbot qualifies property buyers and renters automatically, saving our agents countless hours while increasing our lead volume."
                  </p>
                  <p className="success-story-author">- Michael Rodriguez, CEO</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="success-story-card">
                <div className="success-story-content">
                  <div className="success-story-logo">
                    <img src="/images/clients/client-3.png" alt="EduLearn" />
                  </div>
                  <h4>EduLearn</h4>
                  <p className="success-story-industry">Online Education</p>
                  <div className="success-story-stats">
                    <div className="stat">
                      <h5>215%</h5>
                      <p>More course enrollments</p>
                    </div>
                    <div className="stat">
                      <h5>68%</h5>
                      <p>Cost reduction</p>
                    </div>
                  </div>
                  <p className="success-story-quote">
                    "The AI chatbot helps prospective students find the right courses and guides them through the enrollment process, dramatically increasing our conversion rate."
                  </p>
                  <p className="success-story-author">- David Park, Growth Lead</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default LeadGeneration;
